var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.2 16",
    style: {
      enableBackground: "new 0 0 16.2 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#E0611A;}\r\n\t.st1{fill:none;stroke:#707070;}\r\n\t.st2{fill:none;stroke:#E0611A;stroke-linecap:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-1048.843 -394.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    transform: "translate(1055.091 400.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    className: "st0",
    d: "M8.8,5.5L5,9.3c-0.1,0.1-0.3,0.1-0.5,0l-9.9-9.9c-0.2-0.2-0.2-0.6,0-0.8c0,0,0,0,0,0L-2-4.9 c0.2-0.2,0.6-0.2,0.8,0c0,0,0,0,0,0L8.8,5c0.1,0.1,0.2,0.3,0.1,0.4C8.8,5.5,8.8,5.5,8.8,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    className: "st1",
    d: "M9.1,9.2c0,0.2-0.1,0.3-0.3,0.3c0,0,0,0,0,0L5,9.4c0,0,0,0,0,0c0,0,0,0,0,0l4-4c0,0,0,0,0,0 L9.1,9.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    className: "st2",
    d: "M9.1,9.2c0,0.2-0.1,0.3-0.3,0.3c0,0,0,0,0,0L5,9.4c0,0,0,0,0,0c0,0,0,0,0,0l4-4c0,0,0,0,0,0 L9.1,9.2z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    className: "st0",
    x1: -3,
    y1: 1.7,
    x2: 1.2,
    y2: -2.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilMain);
export default __webpack_public_path__ + "static/media/pencilMain.70c3a453b2b0592a7c65e40b4d7e00a1.svg";
export { ForwardRef as ReactComponent };